import React, {Component} from 'react';

import axios from 'axios';
import auth0Client from '../Auth';
import {ToastContainer, ToastStore} from 'react-toasts';
import {   withRouter } from "react-router-dom";
//import Claims from '../Claims/Claims';
import {SERVER_URL}  from '../Constants';
import BootstrapTable from 'react-bootstrap-table-next';
import ToolkitProvider, { CSVExport } from 'react-bootstrap-table2-toolkit';
import LostItemFunctions from '../LostItem/LostItemFunctions';
//import { DH_NOT_SUITABLE_GENERATOR } from 'constants';


const { ExportCSVButton } = CSVExport;
// Create our number formatter.
const formatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
});


const shipColumns = [

    { dataField: 'id', sort: true,classes:'text-primary', text: 'ID', filterable:true,  textAlign: 'left', footer:'ID' },
    { dataField: 'updatedOn',sort: true,formatter: LostItemFunctions.formatDateTime,  text: 'Last Updated',  headerStyle: (colum, colIndex) => {
      return { width: '120px', textAlign: 'center' };
    }  },


    { dataField: 'to',sort: true, text: 'To', classes:'text-primary', textAlign: 'left'},
    { dataField: 'shipTo',sort: true, text: 'Address', classes:'text-primary', textAlign: 'left'},

    { dataField: 'guestViewedShipping', sort: true, formatter: formatBool, text: 'Viewed Email', classes:'text-primary', textAlign: 'left'},
    { dataField: 'guestPurchasedLabel', sort: true, formatter: formatBool, text: 'Purchased Label?', classes:'text-primary', textAlign: 'left'},
    { dataField: 'status', sort: true, text: 'Purchase Status', classes:'text-primary', textAlign: 'left'},
    { dataField: 'purchaseDate', sort: true,formatter: LostItemFunctions.formatDateTime, text: 'Purchased On', classes:'text-primary', textAlign: 'left'},
    { dataField: 'eta', sort: true, text: 'eta', classes:'text-primary', textAlign: 'left'},
    { dataField: 'amount', sort: true,formatter:formatStripeAmount, text: 'amount', classes:'text-primary', textAlign: 'right', footer: columnData => columnData.reduce((acc, item) => acc + item, 0), footerFormatter: formatStripeAmount,},
    { dataField: 'shippingFee', sort: true,formatter:formatAmount, text: 'Shipping Fee Charged', classes:'text-primary', textAlign: 'right', footer: columnData => columnData.reduce((acc, item) => acc + item, 0)},


   
  
  ];

  function formatBool(cell,row){
    try {
        if (cell){
            
            return (cell) ? 'YES' :' NO';
        }else{
            return  'NO';
        }
    }catch(e){
        return  'NO';

    }
  }

  function formatAmount (cell,row){
    try {
        if (cell){
           
            //return Math.round(parseFloat(cell)/100,2);
            return formatter.format(parseFloat(cell));
        }else{
            return  '';
        }
    }catch(e){
        return  '';

    }
  }
  function formatStripeAmount (cell,row){
    try {
        if (cell){
           
            //return Math.round(parseFloat(cell)/100,2);
            return formatter.format(parseFloat(cell)/100);
        }else{
            return  '';
        }
    }catch(e){
        return  '';

    }
  }

  const defaultSorted = [{
    dataField: 'updatedOn',
    order: 'desc'
  }];
  

  class ShipmentSummaryReport extends Component {
    constructor(props) {
      super(props);
        this.state = { results: []}
        this._input = null;
    }
    async componentDidMount() {


        // console.log("Component did load. Auth : " + auth0Client.getIdToken());
         
         this.loadLostItemData();
       
     
       }

       loadLostItemData = () =>{
        try {
          axios.get(`${SERVER_URL}/Reports/ShippingDetail`,{
             headers: { 
               'Authorization': `Bearer ${auth0Client.getIdToken()}`,
               'venueId' : auth0Client.getActiveVenuedId()
             }
           }).then((res)=>{
             
             if (res.status === 401) {
               //place your reentry code
               console.log("Error" + res.status);
              
              }
     
             const results = res.data.results;
            
             

             this.setState({
              results : results,
               
              });


            });
        }catch(e){

        }
    }


    renderToast=()=>{
        return <div>
            
            <ToastContainer position={ToastContainer.POSITION.TOP_RIGHT} lightBackground store={ToastStore}/>
        </div>
      }

      print=()=>{
       
            // STEP 1: Create a new window, a div, and append it to the window. The div 
            // *MUST** be created by the window it is to be appended to (Edge only)
          

            this.externalWindow = window.open('', '', 'width=600,height=400,left=200,top=250');
            var ss = document.createElement("link"); ss.type = "text/css"; ss.rel = "stylesheet"; ss.href = "https://bootswatch.com/4/lux/bootstrap.min.css"; 
            this.externalWindow.document.getElementsByTagName("head")[0].appendChild(ss);


            this.containerEl = this.externalWindow.document.createElement('div');
            this.externalWindow.document.body.appendChild(this._input);
        
      }
      renderGrid=()=>{
        return (
    
          <div >
           
           
           {this.renderToast()}
           {this.state.lostItems === null && <p>Shipment Details...</p>}
            <ToolkitProvider 
            bootstrap4
              keyField='id' 
              data={ this.state.results } 
              columns={ shipColumns } 
              exportCSV
              defaultSorted={defaultSorted}
             
              >
              {
        props => (
          <div>
        
           <ExportCSVButton { ...props.csvProps }>Export CSV for Printing</ExportCSVButton>
           
        <hr />
            <BootstrapTable
            
              striped
                condensed
             
              
              { ...props.baseProps }
             
            />
          </div>
        )
      }</ToolkitProvider>
    
          </div>
    
    
        )
    
        
      }
    

    render(){

        return(

            <div className="text-center" ref={c => (this._input = c)}> <h5> Shipment Details Report </h5>
            <h6>{LostItemFunctions.formatDate(Date())}</h6>
              {this.renderToast()}
              {this.renderGrid()}
            
            </div>

        )



    }
}


export default withRouter(ShipmentSummaryReport);